/* unplugin-vue-components disabled */import { render } from "./onboarding.vue?vue&type=template&id=3da894de&scoped=true"
import script from "./onboarding.vue?vue&type=script&lang=js"
export * from "./onboarding.vue?vue&type=script&lang=js"

import "./onboarding.vue?vue&type=style&index=0&id=3da894de&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da894de"],['__file',"src/components/ai-chat-v2/ai-assistant/onboarding.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3da894de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3da894de', __exports__)) {
    api.reload('3da894de', __exports__)
  }
  
  module.hot.accept("./onboarding.vue?vue&type=template&id=3da894de&scoped=true", () => {
    api.rerender('3da894de', render)
  })

}


export default __exports__